export function buildClassName(parts: (string | undefined)[]): string {
  return parts.filter(part => typeof part === "string" && part.length > 0).join(" ")
}
